import React from 'react';
import '../common/btn.css'

const Btn = (props) => {
    return (<>

        <button className='btn'>{props.btnt}</button>
    </>);
}

export default Btn;